import script from "./paginator.vue?vue&type=script&setup=true&lang=ts"
export * from "./paginator.vue?vue&type=script&setup=true&lang=ts"

import "./paginator.vue?vue&type=style&index=0&id=6e431e2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e431e2c"]])

export default __exports__